// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__yvNgO","title":"Images90_title__1JqYr","images":"Images90_images__YaTTw"};